import Vue from "vue";
import Router from "vue-router";
import AdminAdd from "./components/user-management/Add.vue";
import AdvisorActionEditor from "./components/advisor/ActionEditor.vue";
import Employers from "./components/employer-management/Employers.vue";
import Employer from "./components/employer-management/Employer.vue";
import Partners from "./components/partners/Partners.vue";
import PartnerDetails from "./components/partners/PartnerDetails.vue";
import PartnerUsers from "@/shared/components/partners/PartnerUsers.vue";
import PartnerUserAdd from "@/shared/components/partners/PartnerUserAdd.vue";
import PartnerSettingsPage from "./components/partners/PartnerSettingsPage.vue";
import AdminReports from "@/shared/components/reporting/AdminReports.vue";
import AdminBillingDetail from "@/shared/components/reporting/AdminBillingDetail.vue";
import AdminBillingEmployeeFees from "@/shared/components/reporting/AdminBillingEmployeeFees.vue";
import AdminBillingSummary from "@/shared/components/reporting/AdminBillingSummary.vue";
import AdminUtility from "./components/utility/Utility.vue";
import AdminUtilityUserEnableDisableAccount from "./components/utility/AdminUtilityUserEnableDisableAccount.vue";
import AdminUtilityReindexUser from "./components/utility/AdminUtilityReindexUser.vue";
import AdminUtilityPendingTx from "./components/utility/AdminUtilityPendingTx.vue";
import AdminUtilityInstantTransferFailures from "./components/utility/AdminUtilityInstantTransferFailures.vue";
import AdminUtilityReimbursementFailures from "./components/utility/AdminUtilityReimbursementFailures.vue";
import AdminFinicityLinkedAccounts from "./components/utility/AdminFinicityLinkedAccounts.vue";
import AdminSftpTestFiles from "./components/utility/AdminUtilitySftpTestFiles.vue";
import AdminUtilityFraudCheckQueue from "./components/utility/fraud/AdminUtilityFraudCheckQueue.vue";
import AdminFraudPreventionReport from "@/shared/components/reporting/AdminFraudPrevention.vue";
import AdminUtilityMfaDisable from "./components/utility/AdminUtilityMfaDisable.vue";
import AdminDemoUsersReport from "@/shared/components/reporting/AdminDemoUsersReport.vue";
import AdminEmailChange from "./components/utility/AdminEmailChange.vue";
import AdminDobNameChange from "./components/utility/AdminDobNameChange.vue";
import PasswordReset from "./components/utility/PasswordReset.vue";
import LinkedBankAccountManagement from "./components/utility/LinkedBankAccountManagement.vue";
import FraudCheckQueueDetail from "./components/utility/fraud/FraudCheckQueueDetail.vue";
import ResetUserCustodian from "./components/utility/ResetUserCustodian.vue";
import SalesPersons from "@/admin/components/salesPerson/SalesPersons.vue";
import EditSalesPerson from "@/admin/components/salesPerson/EditSalesPerson.vue";
import Security from "./components/settings/Security.vue";
import PersonalContributionList from "./components/personal-contribution/List.vue";
import TransactionEdit from "./components/transaction-edit/List.vue";
import EmployerRolePermissions from "./components/utility/EmployerRolePermissions.vue";
import QuickSightReportsList from "./components/utility/QuickSightReportsList.vue";
import QuickSightReportManage from "./components/utility/QuickSightReportManage.vue";
import SigningDocuments from "./components/signing-documents/SigningDocumentList.vue";
import SigningDocumentEditor from "./components/signing-documents/SigningDocumentEditor.vue";
import RiskQuizAgePortfolio from "./components/utility/RiskQuizAgePortfolios.vue";
import RiskQuizAgeRevision from "./components/utility/RiskQuizAgeRevisions.vue";
import InstrumentList from "./components/utility/dwInstrument/InstrumentList.vue";
import OpenSearchUtility from "./components/utility/OpenSearchUtility.vue";
import StateMachineUtility from "./components/utility/StateMachineUtility.vue";
import CardCustomization from "./components/utility/CardCustomization.vue";
import CardCustomizationBulkImport from "./components/utility/CardCustomizationBulkImport.vue";
import AdminReopenUmbAccount from "./components/utility/AdminReopenUmbAccount.vue";
import AdminTestUsers from "./components/utility/AdminTestUsers.vue";
import OutageNotificationConfiguration from "./components/utility/OutageNotificationConfiguration.vue";
import Users from "@/admin/components/shared/Users.vue";
import UmbAccountUsers from "@/admin/components/shared/UmbAccountUsers.vue";
import ManageThemes from "./components/utility/ManageThemes.vue";
import ManageTheme from "./components/utility/ManageTheme.vue";
import MobileAppList from "./components/utility/mobile/MobileAppList.vue";
import ManageMobileApp from "./components/utility/mobile/ManageMobileApp.vue";
import DemoConfigPage from "@/admin/components/demo-config/DemoConfigPage.vue";
import TransferOutCampaigns from "./components/utility/TransferOutCampaigns.vue";
import RolePermissionList from "./components/role-permissions-management/RolePermissionList.vue";
import RoleAdd from "./components/role-permissions-management/RoleAdd.vue";
import * as RouteNames from "./route-names";
import * as Constants from "./constants";
import { LoginRoutes, LoginRouteNames } from "@/shared/loginRoutes";
import RuleEditor3 from "@/admin/components/advisor/RuleEditor3.vue";
import RuleList from "@/admin/components/advisor/RuleList.vue";
import ActionList from "@/admin/components/advisor/ActionList.vue";
import RuleHelp from "@/admin/components/advisor/RuleHelp.vue";
import AdminUtilityUmbDeleteLinkedAccount from "./components/utility/AdminUtilityUmbDeleteLinkedAccount.vue";
import CreateTransferOutCampaign from "./components/utility/CreateTransferOutCampaign.vue";
import ViewEditCampaign from "./components/ebto/view-edit-campaign.vue";
import OmnibusTransactionCodeManagement from "./components/utility/OmnibusTransactionCodeManagement.vue";
import DWInstrument from "./components/utility/dwInstrument/DWInstrument.vue";
import { UserPermission, AuthType } from "@/shared/types";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { useRolePermissionsStore } from "@/shared/store/rolePermissions";
import { useUserStore } from "@/shared/store/user";
import { useLoginRedirectStore } from "@/shared/store/loginRedirect";
import { useNotifierStore } from "@/shared/store/notifier";
import AdminUserManagement from "./components/admin-users/admin-user-management.vue";
import CreateAdminUser from "./components/admin-users/create-admin-user.vue";
import EditAdminUser from "./components/admin-users/edit-admin-user.vue";
import HsabCpfBlackoutManagement from "@/admin/components/utility/HsabCpfBlackoutManagement.vue";
import RepointInvestmentAccount from "@/admin/components/utility/RepointInvestmentAccount.vue";
import InvestmentRepointRequests from "@/admin/components/utility/InvestmentRepointRequests.vue";
import RoleEdit from "./components/role-permissions-management/RoleEdit.vue";
import InvestmentAccountClose from "@/admin/components/utility/InvestmentAccountClose.vue";
import PartnerUserBulkActions from "@/admin/components/partners/PartnerUserBulkActions.vue";
import PartnerUserBulkAdd from "@/admin/components/partners/PartnerUserBulkAdd.vue";
import PartnerUserBulkDelete from "@/admin/components/partners/PartnerUserBulkDelete.vue";
import ConsumerDetail from "@/admin/components/consumer/ConsumerDetail.vue";
import ConsumerSearch from "@/admin/components/consumer/ConsumerSearch.vue";
import WexDisableLegacyInvestment from "@/admin/components/utility/WexDisableLegacyInvestment.vue";

const routeToName = (routeName: string) => ({ name: routeName });

const router = new Router({
    routes: [
        ...LoginRoutes,
        {
            path: "/",
            name: RouteNames.Home,
            component: AdminUtility
        },
        {
            path: "/add",
            name: RouteNames.Add,
            component: AdminAdd,
            beforeEnter: (to, from, next) => {
                const featureFlagStore = useFeatureFlagStore();
                if (!featureFlagStore.flags.hsa4475allowRolePermissions) {
                    next();
                }
            }
        },
        {
            path: "/advisor/rule/help",
            name: RouteNames.AdvisorRuleHelp,
            component: RuleHelp,
            beforeEnter: (to, from, next) => {
                const featureFlagStore = useFeatureFlagStore();
                const rolePermissionsStore = useRolePermissionsStore();

                if (featureFlagStore.flags.hsa4475allowRolePermissions &&
                    !rolePermissionsStore.userPermissions
                        .some(x => x === UserPermission.AdminPortalAdvisorView || x ===
                            UserPermission.AdminPortalAdvisorEdit)) {
                    // do not navigate
                } else {
                    next();
                }
            }
        },
        {
            path: "/security",
            name: RouteNames.Security,
            component: Security
        },
        {
            path: "/advisor/action/:actionId?",
            name: RouteNames.AdvisorAction,
            component: AdvisorActionEditor,
            props: route => ({
                actionId: route.params.actionId
            }),
            beforeEnter: (to, from, next) => {
                const featureFlagStore = useFeatureFlagStore();
                const rolePermissionsStore = useRolePermissionsStore();
                if (featureFlagStore.flags.hsa4475allowRolePermissions &&
                    !rolePermissionsStore.userPermissions
                        .some(x => x === UserPermission.AdminPortalAdvisorEdit || x ===
                            UserPermission.AdminPortalAdvisorView)) {
                    // do not navigate
                } else {
                    next();
                }
            }
        },
        {
            path: "/advisor/actions",
            name: RouteNames.AdvisorActionList3,
            component: ActionList,
            beforeEnter: (to, from, next) => {
                const featureFlagStore = useFeatureFlagStore();
                const rolePermissionsStore = useRolePermissionsStore();
                if (featureFlagStore.flags.hsa4475allowRolePermissions &&
                    !rolePermissionsStore.userPermissions
                        .some(x => x === UserPermission.AdminPortalAdvisorView || x ===
                            UserPermission.AdminPortalAdvisorEdit)) {
                    // do not navigate
                } else {
                    next();
                }
            }
        },
        {
            path: "/advisor/rule/:ruleId?",
            name: RouteNames.AdvisorRule3,
            component: RuleEditor3,
            props: route => ({
                ruleId: route.params.ruleId
            }),
            beforeEnter: (to, from, next) => {
                const featureFlagStore = useFeatureFlagStore();
                const rolePermissionsStore = useRolePermissionsStore();
                if (featureFlagStore.flags.hsa4475allowRolePermissions &&
                    !rolePermissionsStore.userPermissions
                        .some(x => x === UserPermission.AdminPortalAdvisorView || x ===
                            UserPermission.AdminPortalAdvisorEdit)) {
                    // do not navigate
                } else {
                    next();
                }
            }
        },
        {
            path: "/advisor/rules",
            name: RouteNames.AdvisorRuleList3,
            component: RuleList,
            beforeEnter: (to, from, next) => {
                const featureFlagStore = useFeatureFlagStore();
                const rolePermissionsStore = useRolePermissionsStore();
                if (featureFlagStore.flags.hsa4475allowRolePermissions &&
                    !rolePermissionsStore.userPermissions
                        .some(x => x === UserPermission.AdminPortalAdvisorView || x ===
                            UserPermission.AdminPortalAdvisorEdit)) {
                    // do not navigate
                } else {
                    next();
                }
            }
        },
        {
            path: "/employers/:page?",
            name: RouteNames.Employers,
            component: Employers,
            props: route => ({
                routeToEmployerList: page => ({
                    name: RouteNames.Employers,
                    params: {
                        page
                    }
                }),
                page: parseInt(route.params.page) || 1
            }),
            beforeEnter: (to, from, next) => {
                if (!hasAccess([ UserPermission.AdminPortalEmployerView, UserPermission.AdminPortalEmployerEdit ])) {
                    // do not navigate
                } else {
                    next();
                }
            }
        },
        {
            path: "/employer/:employerId/:tab?",
            name: RouteNames.Employer,
            component: Employer,
            props: route => ({
                employerId: parseInt(route.params.employerId) || 0,
                activeTab: route.params.tab,
                changePartner: route.query.changePartner,
                routeToEmployer: (args: { changePartner: string }) => ({
                    name: RouteNames.Employer,
                    params: {
                        employerId: parseInt(route.params.employerId) || 0,
                        tab: route.params.tab
                    },
                    query: {
                        changePartner: args.changePartner
                    },
                }),
                navigate: ({ tab }: { tab: string }) => ({
                    name: RouteNames.Employer,
                    params: (tab)
                        ?
                        { employerId: route.params.employerId, tab }
                        : { employerId: route.params.employerId }
                })
            }),
            beforeEnter: (to, from, next) => {
                if (!hasAccess([ UserPermission.AdminPortalEmployerView, UserPermission.AdminPortalEmployerEdit ])) {
                    // do not navigate
                } else {
                    next();
                }
            }
        },
        {
            path: "/partners/:pageNumber?",
            name: RouteNames.Partners,
            component: Partners,
            props: route => ({
                routeToPartnerList: pageNumber => ({
                    name: RouteNames.Partners,
                    params: {
                        pageNumber
                    }
                }),
                pageNumber: parseInt(route.params.pageNumber) || 1
            }),
            beforeEnter: (to, from, next) => {
                if (!hasAccess([ UserPermission.AdminPortalPartnerEdit, UserPermission.AdminPortalPartnerView ])) {
                    // do not navigate
                } else {
                    next();
                }
            }
        },
        {
            path: "/partner-user-bulk-actions/mass-add/:pageNumber?",
            name: RouteNames.PartnerUserBulkMassAdd,
            component: PartnerUserBulkAdd,
            props: route => ({
                pageNumber: parseInt(route.params.pageNumber) || 1,
                routeToBulkAddView: pageNumber => ({
                    name: RouteNames.PartnerUserBulkMassAdd,
                    params: {
                        pageNumber
                    }
                }),
            })
        },
        {
            path: "/partner-user-bulk-actions/mass-delete/:pageNumber?",
            name: RouteNames.PartnerUserBulkMassDelete,
            component: PartnerUserBulkDelete,
            props: route => ({
                pageNumber: parseInt(route.params.pageNumber) || 1,
                routeToBulkDeleteView: pageNumber => ({
                    name: RouteNames.PartnerUserBulkMassDelete,
                    params: {
                        pageNumber
                    }
                }),
            })
        },
        {
            path: "/partner-user-bulk-actions/:page?",
            name: RouteNames.PartnerUserBulkActions,
            component: PartnerUserBulkActions,
            beforeEnter: (to, from, next) => {
                const featureFlagStore = useFeatureFlagStore();
                if (!featureFlagStore.flags.partnerBulkActions || !hasAccess([UserPermission.AdminPortalPartnerEdit])) {
                    // do not navigate
                }
                else {
                    next();
                }
            },
            props: route => ({
               routeToMassAdd: routeToName(RouteNames.PartnerUserBulkMassAdd),
               routeToMassDelete: routeToName(RouteNames.PartnerUserBulkMassDelete)
            })
        },
        {
            path: "/partner/:partnerId?",
            name: RouteNames.PartnerDetails,
            component: PartnerDetails,
            props: route => ({
                routeToPartnerList: pageNumber => ({
                    name: RouteNames.Partners,
                    params: {
                        pageNumber
                    }
                }),
                routeToPartner: partnerId => ({
                    name: RouteNames.PartnerDetails,
                    params: {
                        partnerId
                    }
                }),
                partnerId: parseInt(route.params.partnerId)
            }),
            beforeEnter: (to, from, next) => {
                if (!hasAccess([ UserPermission.AdminPortalPartnerEdit, UserPermission.AdminPortalPartnerView ])) {
                    // do not navigate
                } else {
                    next();
                }
            }
        },
        {
            path: "/consumer/search",
            name: RouteNames.ConsumerSearch,
            component: ConsumerSearch,
            props: route => ({
                routeToConsumerDetail: (username: string) => ({
                    name: RouteNames.ConsumerDetail,
                    params: {
                        username
                    }
                })
            })
        },
        {
            path: "/consumer/:username?",
            name: RouteNames.ConsumerDetail,
            component: ConsumerDetail,
            props: route => {
                const schedulesPage = route.query && route.query.schedulesPage
                    ? parseInt(<string>route.query.schedulesPage, 10)
                    : 1;
                const tab = (route.query && route.query.tab) || "activity";
                const activityPage = route.query && route.query.activityPage
                    ? parseInt(<string>route.query.activityPage, 10)
                    : 1;
                return {
                    username: route.params.username,
                    schedulesPage: isNaN(schedulesPage) ? 1 : schedulesPage,
                    tab,
                    activityPage: isNaN(activityPage) ? 1 : activityPage,
                };
            }
        },
        {
            path: "/partner/:partnerId/:tab?",
            name: RouteNames.PartnerSettingsPage,
            component: PartnerSettingsPage,
            props: route => ({
                partnerId: route.params.partnerId,
                activeTab: route.params.tab,
                navigate: ({ tab }: { tab: string }) => ({
                    name: RouteNames.PartnerSettingsPage,
                    params: (tab)
                        ?
                        { partnerId: route.params.partnerId, tab }
                        : { partnerId: route.params.partnerId }
                })

            }),
            beforeEnter: (to, from, next) => {
                if (!hasAccess([ UserPermission.AdminPortalPartnerEdit, UserPermission.AdminPortalPartnerView ])) {
                    // do not navigate
                } else {
                    next();
                }
            }
        },
        {
            path: "/partner/:partnerId/users/:userPageNumber?",
            name: RouteNames.PartnerUsers,
            component: PartnerUsers,
            props: route => ({
                partnerId: parseInt(route.params.partnerId),
                userPageNumber: parseInt(route.params.userPageNumber) || 1
            }),
            beforeEnter: (to, from, next) => {
                if (!hasAccess([ UserPermission.AdminPortalPartnerEdit, UserPermission.AdminPortalPartnerView ])) {
                    // do not navigate
                } else {
                    next();
                }
            }
        },
        {
            path: "/partner/:partnerId/addUser",
            name: RouteNames.PartnerUserAdd,
            component: PartnerUserAdd,
            props: route => ({
                routeToPartnerUserList: partnerId => ({
                    name: RouteNames.PartnerUsers,
                    params: {
                        partnerId: parseInt(route.params.partnerId),
                        userPageNumber: 1
                    }
                }),
                partnerId: parseInt(route.params.partnerId),
            })
        },
        {
            path: "/salesPerson",
            name: RouteNames.SalesPersons,
            component: SalesPersons
        },
        {
            path: "/salesPerson/update/:salesPersonId?",
            name: RouteNames.SalesPersonAddEdit,
            component: EditSalesPerson,
            props: route => ({
                salesPersonId: route.params.salesPersonId ? parseInt(route.params.salesPersonId) : 0,
            })
        },
        {
            path: "/utility",
            name: RouteNames.Utility,
            component: AdminUtility
        },
        {
            path: "/utility/quicksight-report/:reportId?",
            name: RouteNames.QuickSightReportManage,
            component: QuickSightReportManage,
            props: route => ({
                reportId: route.params.reportId ? parseInt(route.params.reportId) : 0,
            }),
            beforeEnter: (to, from, next) => {
            if (!hasAccess([ UserPermission.AdminPortalUtilityQuickSightReptEdit])) {
                    // do not navigate
            } else {
                    next();
                }
            }
        },
        {
            path: "/utility/account-enable-disable/:page?",
            name: RouteNames.AdminUtilityUserEnableDisableAccount,
            component: AdminUtilityUserEnableDisableAccount,
            props: route => ({
                page: parseInt(route.params.page) || 1,
                routeToUserList: page => ({
                    name: RouteNames.AdminUtilityUserEnableDisableAccount,
                    params: {
                        page
                    }
                })
            }),
            beforeEnter: (to, from, next) => {
                if (!hasAccess([ UserPermission.AdminPortalUtilityUserEnableDisableAccount ])) {
                    // do not navigate
                } else {
                    next();
                }
            }
        },
        {
            path: "/utility/account-reindex/:page?",
            name: RouteNames.AdminUtilityReindexUser,
            component: AdminUtilityReindexUser,
            props: route => ({
                page: parseInt(route.params.page) || 1,
                routeToUserList: page => ({
                    name: RouteNames.AdminUtilityReindexUser,
                    params: {
                        page
                    }
                })
            })
        },
        {
            path: "/utility/pending-tx-clear",
            name: RouteNames.AdminUtilityPendingTx,
            component: AdminUtilityPendingTx,
            beforeEnter: (to, from, next) => {
                if (!hasAccess([ UserPermission.AdminPortalPendingTxClearEdit ])) {
                    // do not navigate
                } else {
                    next();
                }
            }
        },
        {
            path: "/utility/instant-transfer-failures",
            name: RouteNames.AdminUtilityInstantTransferFailures,
            component: AdminUtilityInstantTransferFailures,
            beforeEnter: (to, from, next) => {
                if (!hasAccess([ UserPermission.AdminPortalInstantTransferFailuresEdit ])) {
                    // do not navigate
                } else {
                    next();
                }
            },
            props: route => ({
                buildRoute: detail => ({
                    name: RouteNames.AdminUtilityInstantTransferFailures,
                    query: detail
                }),
                isArchived: route.query.isArchived,
                pageNumber: parseInt("" + (route.query.pageNumber || 1), 10),
                routeToPage: detail => ({
                    name: RouteNames.AdminUtilityInstantTransferFailures,
                    query: {
                        detail
                    }
                }),
                routeToItem: transactionId => ({
                    name: RouteNames.AdminUtilityInstantTransferFailures,
                    query: {
                        transactionId
                    }
                }),
                transactionId: route.query.transactionId
            })
        },
        {
            path: "/utility/reimbursement-failures",
            name: RouteNames.AdminUtilityReimbursementFailures,
            component: AdminUtilityReimbursementFailures,
            beforeEnter: (to, from, next) => {
                if (!hasAccess([ UserPermission.AdminPortalReimbursementFailuresEdit ])) {
                    // do not navigate
                } else {
                    next();
                }
            },
            props: route => ({
                buildRoute: detail => ({
                    name: RouteNames.AdminUtilityReimbursementFailures,
                    query: detail
                }),
                isArchived: route.query.isArchived,
                pageNumber: parseInt("" + (route.query.pageNumber || 1), 10),
                routeToPage: detail => ({
                    name: RouteNames.AdminUtilityReimbursementFailures,
                    query: {
                        detail
                    }
                }),
                routeToItem: reimbursementId => ({
                    name: RouteNames.AdminUtilityReimbursementFailures,
                    query: {
                        reimbursementId
                    }
                }),
                reimbursementId: route.query.reimbursementId
            })
        },
        {
            path: "/utility/sftp-test-files",
            name: RouteNames.AdminSftpTestFiles,
            component: AdminSftpTestFiles,
            beforeEnter: (to, from, next) => {
            if (!hasAccess([ UserPermission.AdminPortalUtilitySftpTestFileEdit])) {
                    // do not navigate
            } else {
                    next();
                }
            }
        },
        {
            path: "/utility/mfa-disable",
            name: RouteNames.AdminUtilityMfaDisable,
            component: AdminUtilityMfaDisable,
            beforeEnter: (to, from, next) => {
                if (!hasAccess([ UserPermission.AdminPortalUtilityUserMFADisable ])) {
                    // do not navigate
                } else {
                    next();
                }
            }
        },
        {
            path: "/utility/hsab-cpf-blackout-management",
            name: RouteNames.HsabCpfBlackoutManagement,
            component: HsabCpfBlackoutManagement,
            beforeEnter: (to, from, next) => {
                if (!hasAccess([ UserPermission.AdminPortalUtilityCpfBlackoutDateManagementEdit ])) {
                    // do not navigate
                } else {
                    next();
                }
            }
        },
        {
            path: "/utility/repoint-investment-account",
            name: RouteNames.RepointInvestmentAccount,
            component: RepointInvestmentAccount,
            beforeEnter: (to, from, next) => {
                if (!hasAccess([ UserPermission.AdminPortalUtilityRepointUserInvestmentAccountsEdit ])) {
                    // do not navigate
                } else {
                    next();
                }
            }
        },
        {
            path: "/utility/respoint-investment-account-requests/:page?",
            name: RouteNames.RepointInvestmentRequests,
            component: InvestmentRepointRequests,
            props: route => ({
                routeToRepointRequests: page => ({
                    name: RouteNames.RepointInvestmentRequests,
                    params: {
                        page
                    }
                }),
                page: parseInt(route.params.page) || 1
            }),
            beforeEnter: (to, from, next) => {
                if (!hasAccess([ UserPermission.AdminPortalUtilityRepointUserInvestmentAccountRequestsView ])) {
                    // do not navigate
                } else {
                    next();
                }
            }
        },
        {
            path: "/utility/investment-account-close/:page?",
            name: RouteNames.InvestmentAccountClose,
            component: InvestmentAccountClose,
            props: route => ({
                routeToAccountCloseManagement: page => ({
                    name: RouteNames.InvestmentAccountClose,
                    params: {
                        page
                    }
                }),
                page: parseInt(route.params.page) || 1
            })
        },
        {
            path: "/utility/password-reset",
            name: RouteNames.AdminPasswordReset,
            component: PasswordReset,
            beforeEnter: (to, from, next) => {
                if (!hasAccess([ UserPermission.AdminPortalUtilityUserPasswordReset ])) {
                    // do not navigate
                } else {
                    next();
                }
            }
        },
        {
            path: "/utility/employer-role-permissions",
            name: RouteNames.EmployerRolePermissions,
            component: EmployerRolePermissions,
            beforeEnter: (to, from, next) => {
            if (!hasAccess([ UserPermission.AdminPortalUtilityGlobalRolePermissionEdit ])) {
                    // do not navigate
            } else {
                    next();
                }
            }
        },
        {
            path: "/utility/quicksight-reports",
            name: RouteNames.QuickSightReportsList,
            component: QuickSightReportsList,
            beforeEnter: (to, from, next) => {
            if (!hasAccess([ UserPermission.AdminPortalUtilityQuickSightReptEdit ])) {
                    // do not navigate
            } else {
                    next();
                }
            }
        },
        {
            path: "/utility/fraud-check/:pageNumber?",
            name: RouteNames.AdminUtilityFraudCheckQueue,
            component: AdminUtilityFraudCheckQueue,
            beforeEnter: (to, from, next) => {
                if (!hasAccess([ UserPermission.AdminPortalFraudCheckQueueEdit ])) {
                    // do not navigate
                } else {
                    next();
                }
            },
            props: route => ({
                routeToFraudCheckList: pageNumber => ({
                    name: RouteNames.AdminUtilityFraudCheckQueue,
                    params: {
                        pageNumber
                    }
                }),
                pageNumber: parseInt(route.params.pageNumber) || 1
            })
        },
        {
            path: "/utility/fraud-check-detail/:queueId?",
            name: RouteNames.FraudCheckDetail,
            component: FraudCheckQueueDetail,
            beforeEnter: (to, from, next) => {
                if (!hasAccess([ UserPermission.AdminPortalFraudCheckQueueEdit ])) {
                    // do not navigate
                } else {
                    next();
                }
            },
            props: route => ({
                routeToFraudCheckList: pageNumber => ({
                    name: RouteNames.AdminUtilityFraudCheckQueue,
                    params: {
                        pageNumber
                    }
                }),
                routeToFraudDetail: queueId => ({
                    name: RouteNames.FraudCheckDetail,
                    params: {
                        queueId
                    }
                }),
                queueId: route.params.queueId
            })
        },
        {
            path: "/utility/reopen-umb-account/:page?",
            name: RouteNames.ReopenAccountUtilityUsers,
            component: UmbAccountUsers,
            props: route => ({
                title: Constants.UmbAccountOpenerTitle,
                subtitle: Constants.UmbAccountOpenerSubtitle,
                page: parseInt(route.params.page) || 1,
                actionButtonOptions: {
                    show: true,
                    text: "Select",
                    to: umbAccountUserId => ({
                        name: RouteNames.ReopenAccountUtility,
                        params: {
                            umbAccountUserId
                        }
                    })
                },
                routeToUserList: page => ({
                    name: RouteNames.ReopenAccountUtilityUsers,
                    params: {
                        page
                    }
                })
            }),
            beforeEnter: (to, from, next) => {
                if (!hasAccess([ UserPermission.AdminPortalUtilityUMBAccountOpenerEdit ])) {
                    // do not navigate
                } else {
                    next();
                }
            }
        },
        {
            path: "/utility/reopen-umb-account/user/:umbAccountUserId",
            name: RouteNames.ReopenAccountUtility,
            component: AdminReopenUmbAccount,
            props: route => ({
                routeToFraudCheckList: pageNumber => ({
                    name: RouteNames.ReopenAccountUtility,
                    params: {
                        pageNumber
                    }
                }),
                pageNumber: parseInt(route.params.pageNumber) || 1,
                umbAccountUserId: parseInt(route.params.umbAccountUserId) || 0
            }),
            beforeEnter: (to, from, next) => {
                if (!hasAccess([ UserPermission.AdminPortalUtilityUMBAccountOpenerEdit ])) {
                    // do not navigate
                } else {
                    next();
                }
            }
        },
        {
            path: "/utility/reset-user-custodian",
            name: RouteNames.ResetUserCustodian,
            component: ResetUserCustodian,
            meta: {
                notifies_forward: true,
            },
            beforeEnter: (to, from, next) => {
                if (!hasAccess([ UserPermission.AdminPortalUtilityResetUserCustodianEdit ])) {
                    // do not navigate
                } else {
                    next();
                }
            }
        },
        {
            path: "/utility/personal-contribution",
            name: RouteNames.PersonalContributionQueue,
            component: PersonalContributionList,
            beforeEnter: (to, from, next) => {
                if (!hasAccess([ UserPermission.AdminPortalPersonalContributionsEdit ])) {
                    // do not navigate
                } else {
                    next();
                }
            },
            props: route => ({
                routeToPage: pageNumber => ({
                    name: RouteNames.PersonalContributionQueue,
                    query: {
                        pageNumber
                    }
                }),
                routeToItem: detailId => ({
                    name: RouteNames.PersonalContributionQueue,
                    query: {
                        detailId
                    }
                }),
                pageNumber: parseInt("" + (route.query.pageNumber || 1), 10),
                detailId: route.query.detailId
            })
        },
        {
            path: "/utility/transaction-edit",
            name: RouteNames.TransactionEdit,
            component: TransactionEdit,
            beforeEnter: (to, from, next) => {
                if (!hasAccess([ UserPermission.AdminPortalTransactionEdit ])) {
                    // do not navigate
                } else {
                    next();
                }
            },
            props: route => ({
                transactionId: route.query.transactionId,
                email: route.query.email,
                postingDate: route.query.postDate,
                first: route.query.firstName,
                last: route.query.lastName,
                account: route.query.account,
                buildRoute: detail => ({
                    name: RouteNames.TransactionEdit,
                    query: detail
                })
            })
        },
        {
            path: "/utility/admin-email-change",
            name: RouteNames.AdminEmailChange,
            component: AdminEmailChange,
            beforeEnter: (to, from, next) => {
                if (!hasAccess([ UserPermission.AdminPortalUtilityUserAdminEmailChange ])) {
                    // do not navigate
                } else {
                    next();
                }
            }
        },
        {
            path: "/utility/admin-dob-name-change/:page?",
            name: RouteNames.AdminDobNameChangeUsers,
            component: Users,
            props: route => ({
                title: Constants.AdminDobNameChangeTitle,
                subtitle: Constants.AdminDobNameChangeSubtitle,
                page: parseInt(route.params.page) || 1,
                actionButtonOptions: {
                    show: true,
                    text: "Edit",
                    to: userId => ({
                        name: RouteNames.AdminDobNameChange,
                        params: {
                            userId
                        }
                    })
                },
                routeToUserList: page => ({
                    name: RouteNames.AdminDobNameChangeUsers,
                    params: {
                        page
                    }
                })
            }),
            beforeEnter: (to, from, next) => {
                if (!hasAccess([ UserPermission.AdminPortalUtilityUserAdminDOBNameChange ])) {
                    // do not navigate
                } else {
                    next();
                }
            }
        },
        {
            path: "/utility/admin-dob-name-change/edit/:userId",
            name: RouteNames.AdminDobNameChange,
            component: AdminDobNameChange,
            props: route => ({
                userId: parseInt(route.params.userId) || 0
            }),
            beforeEnter: (to, from, next) => {
                if (!hasAccess([ UserPermission.AdminPortalUtilityUserAdminDOBNameChange ])) {
                    // do not navigate
                } else {
                    next();
                }
            }
        },
        {
            path: "/utility/admin-linked-account-management",
            name: RouteNames.LinkedBankAccountManagement,
            component: LinkedBankAccountManagement,
            props: route => ({
                page: parseInt(route.params.page) || 1,
                routeToUserList: page => ({
                    name: RouteNames.LinkedBankAccountManagement,
                    params: {
                        page
                    }
                })
            }),
            beforeEnter: (to, from, next) => {
                if (!hasAccess([ UserPermission.AdminPortalUtilityLinkedBankAcctMangEdit ])) {
                    // do not navigate
                } else {
                    next();
                }
            }
        },
        {
            path: "/utility/admin-risk-quiz-age",
            name: RouteNames.RiskQuizAgeRevision,
            component: RiskQuizAgeRevision,
            beforeEnter: (to, from, next) => {
            if (!hasAccess([ UserPermission.AdminPortalUtilityDrvWealthRiskAgeReviEdit ])) {
                    // do not navigate
            } else {
                    next();
                }
            }
        },
        {
            path: "/utility/admin-risk-quiz-portfolio",
            name: RouteNames.RiskQuizAgePortfolio,
            component: RiskQuizAgePortfolio,
            beforeEnter: (to, from, next) => {
            if (!hasAccess([ UserPermission.AdminPortalUtilityDrvWealthRiskAgePortEdit ])) {
                    // do not navigate
            } else {
                    next();
                }
            }
        },
        {
            path: "/utility/admin-instrument-list",
            name: RouteNames.InstrumentList,
            component: InstrumentList
        },
        {
            path: "/utility/admin-wex-disable-legacy-investment",
            name: RouteNames.WexDisableLegacyInvestment,
            component: WexDisableLegacyInvestment
        },
        {
            path: "/utility/drivewealth-instrument/:tab?",
            name: RouteNames.DWInstrument,
            component: DWInstrument,
            props: route => ({
                activeTab: route.params.tab || "list",
                navigate: ({ tab }: { tab: string }) => ({
                    name: RouteNames.DWInstrument,
                    params: { tab }
                })
            }),
            beforeEnter: (to, from, next) => {
            if (!hasAccess([ UserPermission.AdminPortalUtilityDrvWealthInstrLstEdit ])) {
                    // do not navigate
            } else {
                    next();
                }
            }
        },
        {
            path: "/utility/admin-opensearch-utility",
            name: RouteNames.AdminUtilityOpenSearch,
            component: OpenSearchUtility,
            beforeEnter: (to, from, next) => {
                if (!hasAccess([ UserPermission.AdminPortalUtilityOpenSearchEdit ])) {
                        // do not navigate
                } else {
                        next();
                    }
                }
        },
        {
            path: "/utility/admin-statemachine-utility",
            name: RouteNames.AdminUtilityStateMachine,
            component: StateMachineUtility,
            beforeEnter: (to, from, next) => {
            if (!hasAccess([ UserPermission.AdminPortalMonitoredStateMachines ])) {
                    // do not navigate
            } else {
                    next();
                }
            }
        },
        {
            path: "/utitility/card-customization",
            name: RouteNames.CardCustomization,
            component: CardCustomization,
            beforeEnter: (to, from, next) => {
            if (!hasAccess([ UserPermission.AdminPortalUtilityDebitCardCustoEdit ])) {
                    // do not navigate
            } else {
                    next();
                }
            }
        },
        {
            path: "/utitility/card-customization-bulk-import",
            name: RouteNames.CardCustomizationBulkImport,
            component: CardCustomizationBulkImport,
            beforeEnter: (to, from, next) => {
            if (!hasAccess([ UserPermission.AdminPortalDebitCardSettingBulkImport ])) {
                    // do not navigate
            } else {
                    next();
                }
            }
        },
        {
            path: "/utility/outage-notification-config",
            name: RouteNames.OutageNotificationConfiguration,
            component: OutageNotificationConfiguration,
            beforeEnter: (to, from, next) => {
            if (!hasAccess([ UserPermission.AdminPortalUtilityOutageNotifyConfigEdit ])) {
                    // do not navigate
            } else {
                    next();
                }
            }
        },
        {
            path: "/utility/test-users",
            name: RouteNames.AdminTestUsers,
            component: AdminTestUsers
        },
        {
            path: "/utility/finicity-linked-accounts/:page?",
            name: RouteNames.AdminFinicityLinkedAccountsUsers,
            component: Users,
            props: route => ({
                title: Constants.AdminFinicityLinkedAccountsTitle,
                page: parseInt(route.params.page) || 1,
                actionButtonOptions: {
                    show: true,
                    text: "Detail",
                    to: userId => ({
                        name: RouteNames.AdminFinicityLinkedAccounts,
                        params: {
                            userId
                        }
                    })
                },
                routeToUserList: page => ({
                    name: RouteNames.AdminFinicityLinkedAccountsUsers,
                    params: {
                        page
                    }
                })
            }),
            beforeEnter: (to, from, next) => {
                if (!hasAccess([ UserPermission.AdminPortalGetAllPortalUsersRead ])) {
                    // do not navigate
                } else {
                    next();
                }
            }
        },
        {
            path: "/utility/finicity-linked-accounts/detail/:userId",
            name: RouteNames.AdminFinicityLinkedAccounts,
            component: AdminFinicityLinkedAccounts,
            props: route => ({
                userId: route.params.userId,
            }),
            beforeEnter: (to, from, next) => {
                if (!hasAccess([ UserPermission.AdminPortalUtilityLinkedFinicityAcctDtlEdit ])) {
                    // do not navigate
                } else {
                    next();
                }
            }
        },
        {
            path: "/utility/transfer-out",
            name: RouteNames.TransferOutCampaigns,
            component: TransferOutCampaigns
        },
        {
            path: "/utility/transfer-out/create-campaign",
            name: RouteNames.CreateCampaign,
            component: CreateTransferOutCampaign,
            meta: {
                notifies_forward: true,
            }
        },
        {
            path: "/ebto/transfer-out/view-campaign/:campaignKey",
            name: RouteNames.ViewEditCampaign,
            component: ViewEditCampaign,
            props: route => ({
                campaignKey: route.params.campaignKey,
            })
        },
        {
            path: "/reports/",
            name: RouteNames.Reports,
            component: AdminReports,
            beforeEnter: (to, from, next) => {
                if (!hasAccess([ UserPermission.AdminPortalReportsView ])) {
                    // do not navigate
                } else {
                    next();
                }
            }
        },
        {
            path: "/reports/billing-detail",
            name: RouteNames.ReportsAdminBillingDetail,
            component: AdminBillingDetail,
            beforeEnter: (to, from, next) => {
                if (!hasAccess([ UserPermission.AdminPortalReportsView ])) {
                    // do not navigate
                } else {
                    next();
                }
            }
        },
        {
            path: "/reports/billing-employee-fees",
            name: RouteNames.ReportsAdminBillingEmployeeFees,
            component: AdminBillingEmployeeFees,
            beforeEnter: (to, from, next) => {
                if (!hasAccess([ UserPermission.AdminPortalReportsView ])) {
                    // do not navigate
                } else {
                    next();
                }
            }
        },
        {
            path: "/reports/billing-summary",
            name: RouteNames.ReportsAdminBillingSummary,
            component: AdminBillingSummary,
            beforeEnter: (to, from, next) => {
                if (!hasAccess([ UserPermission.AdminPortalReportsView ])) {
                    // do not navigate
                } else {
                    next();
                }
            }
        },
        {
            path: "/reports/fraud-prevention",
            name: RouteNames.ReportsAdminFraudPrevention,
            component: AdminFraudPreventionReport,
            beforeEnter: (to, from, next) => {
                if (!hasAccess([ UserPermission.AdminPortalReportsView ])) {
                    // do not navigate
                } else {
                    next();
                }
            }
        },
        {
            path: "/reports/demo-users",
            name: RouteNames.ReportsAdminDemoUsers,
            component: AdminDemoUsersReport,
            beforeEnter: (to, from, next) => {
                if (!hasAccess([ UserPermission.AdminPortalReportsView ])) {
                    // do not navigate
                } else {
                    next();
                }
            }
        },
        {
            path: "/signing-documents",
            name: RouteNames.SigningDocuments,
            component: SigningDocuments,
            beforeEnter: (to, from, next) => {
                if (!hasAccess([ UserPermission.AdminPortalDocumentView, UserPermission.AdminPortalDocumentEdit ])) {
                    // do not navigate
                } else {
                    next();
                }
            }
        },
        {
            path: "/signing-document/:documentId/version/:version?",
            name: RouteNames.SigningDocumentEditor,
            component: SigningDocumentEditor,
            props: route => ({
                documentId: parseInt(route.params.documentId),
                version: route.params.version || 1.0
            }),
            beforeEnter: (to, from, next) => {
                if (!hasAccess([ UserPermission.AdminPortalDocumentView, UserPermission.AdminPortalDocumentEdit ])) {
                    // do not navigate
                } else {
                    next();
                }
            }
        },
        {
            path: "/utility/manage-theme/:themeId",
            name: RouteNames.ManageTheme,
            component: ManageTheme,
            props: route => ({
                themeId: parseInt(route.params.themeId),
            })
        },
        {
            path: "/utility/manage-themes/:page?",
            name: RouteNames.ManageThemes,
            component: ManageThemes,
            props: route => ({
                routeToThemeList: page => ({
                    name: RouteNames.ManageThemes,
                    params: {
                        page
                    }
                }),
                page: parseInt(route.params.page) || 1
            }),
            beforeEnter: (to, from, next) => {
            if (!hasAccess([ UserPermission.AdminPortalUtilityManageThemeEdit ])) {
                    // do not navigate
            } else {
                    next();
                }
            }
        },
        {
            path: "/utility/mobile-apps/:page?",
            name: RouteNames.MobileAppList,
            component: MobileAppList,
            props: route => ({
                routeToMobileAppList: page => ({
                    name: RouteNames.MobileAppList,
                    params: {
                        page
                    }
                }),
                page: parseInt(route.params.page) || 1
            }),
            beforeEnter: (to, from, next) => {
            if (!hasAccess([ UserPermission.AdminPortalUtilityMobileAppsEdit ])) {
                    // do not navigate
            } else {
                    next();
                }
            }
        },
        {
            path: "/utility/mobile-app/:appid?",
            name: RouteNames.ManageMobileApp,
            component: ManageMobileApp,
            props: route => ({
                appId: parseInt(route.params.appid),
            }),
            beforeEnter: (to, from, next) => {
            if (!hasAccess([ UserPermission.AdminPortalUtilityMobileAppsEdit ])) {
                    // do not navigate
            } else {
                    next();
                }
            }
        },
        {
            path: "/utility/delete-umb-linked-account",
            name: RouteNames.AdminUtilityUmbDeleteLinkedAccount,
            component: AdminUtilityUmbDeleteLinkedAccount,
            beforeEnter: (to, from, next) => {
                if (!hasAccess([ UserPermission.AdminPortalUtilityDeleteUMBLinkAccountEdit ])) {
                    // do not navigate
                } else {
                    next();
                }
            }
        },
        {
            path: "/utility/omnibus-transaction-code-management",
            name: RouteNames.OmnibusTransactionCodeManagement,
            component: OmnibusTransactionCodeManagement,
            beforeEnter: (to, from, next) => {
                if (!hasAccess([ UserPermission.AdminPortalOmnibusTransactionCodeManagementEdit ])) {
                    // do not navigate
                } else {
                    next();
                }
            }
        },
        {
            path: "/demo-config",
            name: RouteNames.DemoConfig,
            component: DemoConfigPage
        },
        {
            path: "/role-permissions-management/role-permission-list",
            name: RouteNames.RolePermissions,
            component: RolePermissionList,
            beforeEnter: (to, from, next) => {
                if (!hasAccess([ UserPermission.AdminPortalUserManagementView, UserPermission.AdminPortalUserManagementEdit ]) && !useFeatureFlagStore().flags.hsa7246AdminInitialUserCreation ) {
                    // do not navigate
                } else {
                    next();
                }
            }
        },
        {
            path: "/role-permissions-management/role-permission-add",
            name: RouteNames.RoleAdd,
            component: RoleAdd,
            beforeEnter: (to, from, next) => {
                if (!hasAccess([ UserPermission.AdminPortalUserManagementEdit ]) && !useFeatureFlagStore().flags.hsa7246AdminInitialUserCreation ) {
                    // do not navigate
                } else {
                    next();
                }
            }
        },
        {
            path: "/role-permissions-management/role-permission-edit/:roleId?",
            name: RouteNames.RoleEdit,
            component: RoleEdit,
            props: route => ({
                roleId: parseInt(route.params.roleId),
            }),
            beforeEnter: (to, from, next) => {
                if (!hasAccess([ UserPermission.AdminPortalUserManagementView, UserPermission.AdminPortalUserManagementEdit ]) && !useFeatureFlagStore().flags.hsa7246AdminInitialUserCreation ) {
                    // do not navigate
                } else {
                    next();
                }
            }
        },
        {
            path: "/admin-users/admin-user-management",
            name: RouteNames.AdminUserManagement,
            component: AdminUserManagement,
            beforeEnter: (to, from, next) => {
                if (!hasAccess([ UserPermission.AdminPortalUserManagementView, UserPermission.AdminPortalUserManagementEdit ]) && !useFeatureFlagStore().flags.hsa7246AdminInitialUserCreation ) {
                    // do not navigate
                } else {
                    next();
                }
            }
        },
        {
            path: "/admin-users/create-admin-user",
            name: RouteNames.CreateAdminUser,
            component: CreateAdminUser,
            meta: {
                notifies_forward: true,
            },
            beforeEnter: (to, from, next) => {
                if (!hasAccess([ UserPermission.AdminPortalUserManagementEdit ]) && !useFeatureFlagStore().flags.hsa7246AdminInitialUserCreation ) {
                    // do not navigate
                } else {
                    next();
                }
            }
        },
        {
            path: "/admin-users/edit-admin-user/:userId?",
            name: RouteNames.EditAdminUser,
            component: EditAdminUser,
            props: route => ({
                userId: parseInt(route.params.userId),
            }),
            meta: {
                notifies_forward: true,
            },
            beforeEnter: (to, from, next) => {
                if (!hasAccess([ UserPermission.AdminPortalUserManagementView, UserPermission.AdminPortalUserManagementEdit ]) && !useFeatureFlagStore().flags.hsa7246AdminInitialUserCreation ) {
                    // do not navigate
                } else {
                    next();
                }
            }
        }
    ]
});

router.beforeEach((to, from, next) => {
    const userStore = useUserStore();
    const loginRedirectStore = useLoginRedirectStore();

    const userLoggedIn = userStore.loggedIn;
    const authType = userStore.authType;
    const redirectRouteObject = loginRedirectStore.routeObject;

    if (authType === AuthType.Okta && (to.name === LoginRouteNames.OktaLogin || to.name === LoginRouteNames.Login)) {
        next({
            name: LoginRouteNames.AdminOktaLogin,
            query: to.query.returnUrl ? to.query : {
                ...to.query,
                returnUrl: RouteNames.Home
            }
        });
        return;
    }
    if (authType === AuthType.Cognito &&
        (to.name === LoginRouteNames.OktaLogin || to.name === LoginRouteNames.AdminOktaLogin)) {
        next({
            name: LoginRouteNames.Login,
            query: to.query.returnUrl ? to.query : {
                ...to.query,
                returnUrl: RouteNames.Home
            }
        });
        return;
    }

    if (!to.matched.some(r => r.meta.allowAnonymous) && !userLoggedIn) {
        if (to.name !== LoginRouteNames.Login
            && to.name !== LoginRouteNames.AdminOktaLogin
            && to.name !== LoginRouteNames.OktaLogin
            && to.name !== RouteNames.Home) {
            loginRedirectStore.setRedirectRouteObject({ ...to });
        }
        next({
            name: authType === AuthType.Okta ? LoginRouteNames.AdminOktaLogin : LoginRouteNames.Login,
            query: to.query.returnUrl ? to.query : {
                ...to.query,
                returnUrl: to.path
            }
        });

    return;
    }

    if (!from.matched.some(r => r.meta.notifies_forward)) {
        const notifierStore = useNotifierStore();
        notifierStore.clearAlerts();
    }

    if (userLoggedIn && redirectRouteObject) {
        loginRedirectStore.setRedirectRouteObject(null);
        next({ ...redirectRouteObject });
        return;
    }

    // redirect to home view if the employer is logged in
    // prevent them from being able to see login/create-account when already logged in

    if (userLoggedIn
        && (to.name === LoginRouteNames.Login
            || to.name === LoginRouteNames.AdminOktaLogin
            || to.name === LoginRouteNames.OktaLogin)) {
        next({ name: RouteNames.Home });
        return;
    }

    // EBTO Only Special Routing
    if (userLoggedIn && hasEbtoOnlyAccess()) {
        const ebtoRoutes = [RouteNames.TransferOutCampaigns, RouteNames.ViewEditCampaign, RouteNames.CreateCampaign];
        if ((to.name !== RouteNames.CreateCampaign
            && to.name !== RouteNames.ViewEditCampaign
            && to.name !== RouteNames.TransferOutCampaigns)
            && ebtoRoutes.filter(x => x = from.name).length > 0) {
            next({ name: RouteNames.TransferOutCampaigns });
            return;
        }
    }

    next();
});

function hasAccess (permissionsToCheck: UserPermission[]): boolean {
    const hasAccess = useFeatureFlagStore().flags.hsa4475allowRolePermissions ?
        permissionsToCheck.filter(
            perm => useRolePermissionsStore().userPermissions.some(
                userPerm => perm === userPerm)).length > 0 : true;
    return hasAccess;
}

function hasEbtoOnlyAccess () {
  const userStore = useUserStore();
  const ebtoPermissions = [UserPermission.AdminPortalEbtoView, UserPermission.AdminPortalEbtoEdit];
  return userStore.user.groups.some(x => x === "ebto-view" || x === "ebto-edit")
  && ebtoPermissions.filter(
    perm => useRolePermissionsStore().userPermissions.some(
        userPerm => perm === userPerm)).length === 0;
}

export default router;